import { render } from "./UiLanguageSwitch.vue?vue&type=template&id=c4771480&ts=true&lang=pug"
import script from "./UiLanguageSwitch.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiLanguageSwitch.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__